import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCardsFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M16.393 18.709q-.372 0-.764-.057l-4.452-.671c-2.605-.392-4.082-2.482-3.674-5.198l.96-6.42c.407-2.717 2.425-4.28 5.035-3.9h.002l4.45.67c2.605.394 4.081 2.483 3.673 5.199l-.959 6.42c-.368 2.443-2.043 3.957-4.27 3.957"
    />
    <path
      fill="currentColor"
      d="m10.953 19.465 2.59.389c.208.031.232.322.032.388l-3.336 1.096a4.9 4.9 0 0 1-1.529.256c-1.853 0-3.405-1.182-4.087-3.243l-2.025-6.16c-.43-1.292-.379-2.579.147-3.623.503-1 1.401-1.737 2.596-2.129l1.437-.472c.11-.036.219.06.202.174l-.96 6.419c-.532 3.547 1.496 6.386 4.933 6.905"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCardsFilled);
export default ForwardRef;
